import * as React from "react";
import { Edit, SimpleForm, TextInput, List, Datagrid, TextField, DateField, Create } from 'react-admin';

const PayrollsTitle = props => {
    return <span>{props.record ? `${props.record.name}` : ''}</span>;
};

export const PayrollsList = props => (
    <List {...props}>
        <Datagrid rowClick="edit">
            <TextField source="code" />
            <TextField source="name" />
            <TextField source="currency" />
            <DateField source="created_at" />
        </Datagrid>
    </List>
);

export const PayrollsEdit = props => (
    <Edit {...props} title={<PayrollsTitle />} undoable={false}>
        <SimpleForm redirect="list">
            <TextInput source="code" />
            <TextInput source="name" />
            <TextInput source="currency" />
        </SimpleForm>
    </Edit>
);

export const PayrollsCreate = props => (
    <Create {...props} title={<PayrollsTitle />} undoable={false} redirect="list">
        <SimpleForm redirect="list">
            <TextInput source="code" />
            <TextInput source="name" />
            <TextInput source="currency" />
        </SimpleForm>
    </Create>
);